import { Component, Input } from '@angular/core';
import { EventItem } from '../../interfaces/event';

@Component({
  selector: 'app-month-events',
  templateUrl: './month-events.component.html',
  styleUrls: ['./month-events.component.scss']
})
export class MonthEventsComponent {
  @Input() monthEvents?: { date: string, events: EventItem[] }[];
  @Input() studentCalendarFilters: any;
  @Input() notificationHeader: string = '';
  @Input() isLoading: boolean = true;
  @Input() submissionLabel: string = '';
  @Input() atHourLabel: string = '';
}
